import * as React from "react";
import { MenuItemLink } from "react-admin";
import StorefrontIcon from "@mui/icons-material/Storefront";

const DeliverySubmenu = (props) => {
  return (
    <div>
      <MenuItemLink
        to="/deliveryCompany"
        primaryText="View All"
        leftIcon={<StorefrontIcon />}
        sx={{
          color: "#fff",
          marginTop: 5,
          "& .RaMenuItemLink-icon": {
            color: "#fff",
          },
        }}
      />
    </div>
  );
};

export default DeliverySubmenu;
